import { ethers } from 'ethers';
import { CPGABI } from '../ABI/ABI';

const DISPUTE_RAISED_EVENTS = ['DisputeRaised'];

/**
 * Reads on-chain disputeId from a raiseDispute transaction receipt.
 */
export function extractDisputeIdFromReceipt(receipt) {
    if (!receipt?.logs?.length) return null;
    const iface = new ethers.Interface(CPGABI);
    for (const log of receipt.logs) {
        try {
            const parsed = iface.parseLog({
                topics: [...log.topics],
                data: log.data,
            });
            if (parsed && DISPUTE_RAISED_EVENTS.includes(parsed.name)) {
                const id = parsed.args?.disputeId ?? parsed.args?.[0];
                if (id === undefined || id === null) return null;
                return Number(id);
            }
        } catch (_e) {
            continue;
        }
    }
    return null;
}
